import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { useTracker } from 'asset-actions-lib/context/TrackerContext';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { useIsCopilotWidgetActive } from 'copilot-toolkit/hooks/useIsCopilotWidgetActive';
import { OBJECT_SUMMARY } from 'chatspot-core/messages/KnownMessageIntents';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function SummarizeButtonInner({
  'data-test-id': dataTestId,
  onClick
}) {
  const {
    applicationId,
    tracker
  } = useTracker();
  const isCopilotWidgetActive = useIsCopilotWidgetActive();
  const {
    crmObject
  } = useAssetActions();
  const usageTrackerAppLocationKey = `${applicationId}:summarize_form`;
  return /*#__PURE__*/_jsx(CopilotActionButton, {
    copilotAction: {
      label: getPropertyValue(crmObject, 'hs_name', ''),
      objectId: String(crmObject.objectId),
      intent: OBJECT_SUMMARY,
      objectTypeId: crmObject.objectTypeId,
      objectTypeLabel: I18n.text('assetActionsLibForms.form')
    },
    "data-test-id": dataTestId,
    disabled: !isCopilotWidgetActive,
    onClick: onClick,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.tooltip.summarizeFormWithCopilot"
    }),
    text: I18n.text('assetActionsLibForms.actions.summarize'),
    usageTracker: tracker,
    useBreezeStyles: false,
    usageTrackerAppLocationKey: usageTrackerAppLocationKey
  });
}
export default function SummarizeActionButton(props) {
  return /*#__PURE__*/_jsx(CopilotProvider, {
    children: /*#__PURE__*/_jsx(SummarizeButtonInner, Object.assign({}, props))
  });
}